import { EditorState, AtomicBlockUtils } from 'draft-js';
import { GifData } from '../gifPlugin';

export default (editorState: EditorState, gif: GifData): EditorState => {
  const contentState = editorState.getCurrentContent();
  const contentStateWithEntity = contentState.createEntity('GIF', 'IMMUTABLE', { src: gif.images.fixed_width.url });
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  const newEditorState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
  return EditorState.forceSelection(newEditorState, newEditorState.getCurrentContent().getSelectionAfter());
};
